var _rect, _circle, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIncorrectCvvCode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#7B66F2",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 44,
    fill: "#7B66F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0486 74H77.9512C78.8907 73.9989 79.7916 73.6624 80.4567 73.0645C81.1215 72.4662 81.4965 71.6552 81.4998 70.8085V56.5789C81.4999 56.5744 81.5 56.5699 81.5 56.5653V52.4349C81.5 52.4303 81.4999 52.4258 81.4998 52.4212V49.1915C81.4966 48.3448 81.1215 47.5338 80.4567 46.9355C79.7915 46.3376 78.8907 46.0011 77.9512 46H41.0486C40.109 46.0011 39.2082 46.3376 38.543 46.9355C37.8783 47.5338 37.5032 48.3448 37.5 49.1915V70.8085C37.5032 71.6552 37.8783 72.4662 38.543 73.0645C39.2083 73.6624 40.109 73.9989 41.0486 74ZM38.4053 57.0001V70.8093C38.4061 71.4408 38.6845 72.0465 39.1804 72.4929C39.6758 72.9397 40.3479 73.1906 41.0487 73.1914H77.9512C78.652 73.1906 79.3241 72.9397 79.8195 72.4929C80.3154 72.0464 80.5938 71.4409 80.5946 70.8093V57.0001H38.4053ZM38.4053 52.0001H80.5946V49.1923C80.5938 48.5608 80.3154 47.9552 79.8195 47.5087C79.3241 47.0619 78.652 46.811 77.9512 46.8103L41.0486 46.8165C40.3491 46.8168 39.6783 47.0674 39.1828 47.5124C38.6873 47.9577 38.4077 48.5619 38.4053 49.1923V52.0001ZM80.5946 52.8697H38.4058V56.1305H80.5946V52.8697Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 50.2858,
    width: 22,
    height: 9,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIncorrectCvvCode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/incorrect-cvv-code.fde1f405efa683bcf31e3110e93c9669.svg";